import React from "react";

function InputErrorTextComponent(props) {
    return props.errorText && (
        <span className="input-error-text">{props.errorText}</span>
    );
}

export default InputErrorTextComponent;